Ext.define('SA.view.quickreport.QuickReport', {
    alias: 'widget.quick-report',
    extend: 'SA.view.SimpleContainer',

    baseCls: 'sa-quick-report',

    items: [
        {
            xtype: 'load-mask',
            itemId: 'loadMask',
            zIndex: 3
        }, {
            xtype: 'component',
            cls: 'sa-quick-report-grid',
            itemId: 'grid'
        }
    ],

    initComponent() {
        var GridTpl = SA.view.quickreport.QuickReportGridTpl;

        this.callParent();

        this.loadMask = this.down('#loadMask');
        this.grid = this.down('#grid');

        this.gridTpl = GridTpl.get();
        this.headerIdentifierElContentTpl = GridTpl.getHeaderIdentifierElContentTpl();

        this.layout = Ext.createByAlias('quickreport.layout', this);
        this.scrollSynchronizer = Ext.createByAlias('quickreport.scroll-synchronizer', this);
        this.dragHandler = Ext.createByAlias('quickreport.drag-handler');

        this.headerCellMenu = Ext.createByAlias('quickreport.header-cell-menu', this);
        this.valueCellMenu = Ext.createByAlias('quickreport.value-cell-menu', this);
    },

    afterRender() {
        this.callParent();

        this.refresh();
    },

    beforeDestroy() {
        this.callParent();

        Ext.destroyMembers(this, 'layout', 'scrollSynchronizer', 'dragHandler', 'headerCellMenu', 'valueCellMenu');
    },

    getDragDelegate(mouseDownPageX, headerCell) {
        var headerEl = this.el.down('.sa-quick-report-header', true),
            initialHeaderXTranslation = getHeaderXTranslation(),
            cellDeltaToPageX = headerCell.offsetLeft - mouseDownPageX,
            headerCellMaxLeft = headerEl.scrollWidth - headerCell.offsetWidth;

        return {
            onClick: this.onHeaderCellClick.bind(this, headerCell),
            onDragEnd: this.onHeaderCellDragEnd.bind(this, headerCell),
            scrollLeftBy: this.scrollLeftBy.bind(this),

            pageXToLeft(pageX) {
                var headerDelta = initialHeaderXTranslation - getHeaderXTranslation(),
                    left = pageX + cellDeltaToPageX + headerDelta;

                return Ext.Number.constrain(left, 0, headerCellMaxLeft);
            }
        };

        function getHeaderXTranslation() {
            return parseFloat(headerEl.style.transform.match(/translate\((-?\d+(?:\.\d+)?)/)[1]);
        }
    },

    initEvents() {
        var el = this.el,
            projectView = this.projectView,
            project = projectView.getProject(),
            menus = [this.headerCellMenu, this.valueCellMenu];

        this.callParent();

        this.setRefreshOnLocationChange(true);

        this.mon(project, 'change:attribute', this.refreshAttributeTupleAddability, this);
        this.mon(projectView, 'change:quickReportTemplate', this.refresh, this);
        this.mon(projectView, 'invoke:addAttribute', this.onAddAttributeInvokedOnView, this);

        this.mon(SA.data.LocationAliases, 'change', this.onAliasChange, this);
        this.mon(SA.data.CustomLocations, 'update:locationItem', this.refresh, this);

        this.mon(SA.Viewport, 'resize', this.onViewportResize, this);

        el.on('click', this.onAddAttributesButtonClick, this, {delegate: '.sa-quick-report-first-col-add-attributes-button'});
        el.on('click', this.onValueCellClick, this, {delegate: '.sa-quick-report-body-value-cell'});
        el.on('mouseover', this.onValueCellMouseover, this, {delegate: '.sa-quick-report-body-value-cell'});
        el.on('mouseout', this.onValueCellMouseout, this, {delegate: '.sa-quick-report-body-value-cell'});

        el.on({
            delegate: '.sa-quick-report-header-cell',
            scope: this,

            mousedown: this.onHeaderCellMouseDown,
            mouseout: this.onHeaderCellMouseOut,
            mouseover: this.onHeaderCellMouseOver
        });

        this.scrollSynchronizer.initEvents();

        menus.forEach(menu => menu.on('show', this.onMenuShow, this));
        menus.forEach(menu => menu.on('hide', this.onMenuHide, this));
    },

    onAddAttributeInvokedOnView() {
        Ext.widget({
            xtype: 'quick-report-add-attribute-invoked-on-view-popup'
        });
    },

    onAddAttributesButtonClick(ev, el) {
        var project = this.projectView.getProject(),
            cell = Ext.fly(el).up('.sa-quick-report-first-col-data-row', false, true),
            attributes = cell.getAttribute('data-attributes').split(' ');

        project.addAttributes(attributes);

        SA.data.RecentAttributes.add(attributes);
    },

    onAliasChange(location, alias) {
        if (!this.projectView.containsLocation(location)) {
            return;
        }

        var identifierElSelector = '.sa-quick-report-header-location-identifier[data-location-series="' + location + '"]',
            identifierEl = this.el.down(identifierElSelector, true),
            locationItem = SA.data.LocationsCache.get(location),
            identifierHtml = this.headerIdentifierElContentTpl.apply({alias, name: locationItem.name});

        identifierEl.innerHTML = identifierHtml;

        this.refreshLayout();
    },

    onHeaderCellClick(el) {
        var location = el.getAttribute('data-location-series'),
            identifierEl = Ext.fly(el).down('.sa-quick-report-header-location-identifier', true);

        this.headerCellMenu.maybeShow({
            location,
            positionEl: identifierEl,
            view: this.projectView,

            onHide() {
                Ext.fly(el).removeCls('sa-quick-report-header-cell-selected');
            },

            onShow() {
                Ext.fly(el).addCls('sa-quick-report-header-cell-selected');
            }
        });
    },

    onHeaderCellDragEnd(el) {
        var view = this.projectView,
            locationSeries = el.getAttribute('data-location-series'),
            index = this.el.query('.sa-quick-report-header-cell').indexOf(el);

        this.setRefreshOnLocationChange(false);

        view.moveLocation(locationSeries, index);
        view.save();

        this.setRefreshOnLocationChange(true);
    },

    onHeaderCellMouseDown(ev, headerCell) {
        var me = this,
            pageX = ev.getPageX(),
            delegate = this.getDragDelegate(pageX, headerCell),
            locationSeries = headerCell.getAttribute('data-location-series'),
            bodyColumn = this.el.down('.sa-quick-report-body-column[data-location-series="' + locationSeries + '"]', true);

        ev.preventDefault();

        this.dragHandler.onMouseDown(delegate, pageX, getVisibleXBounds(), {bodyColumn, headerCell});

        function getVisibleXBounds() {
            var bodyWrap = me.el.down('.sa-quick-report-body-wrap', true),
                bodyOffsetLeft = Ext.fly(bodyWrap).getOffsetsTo(document)[0];

            return {
                left: bodyOffsetLeft,
                right: bodyOffsetLeft + bodyWrap.clientWidth
            };
        }
    },

    onHeaderCellMouseOut(ev, el) {
        Ext.fly(el).removeCls('sa-quick-report-header-cell-over');
    },

    onHeaderCellMouseOver(ev, el) {
        Ext.fly(el).addCls('sa-quick-report-header-cell-over');
    },

    onMenuHide() {
        this.removeCellMenuScrollListener();
    },

    onMenuShow(menu, cellEl) {
        var wrap = this.el.down('.sa-quick-report-body-wrap'),
            getCellXY = () => Ext.fly(cellEl).getXY(),
            initialCellXY = getCellXY(),
            cellMoved = () => !Ext.Array.equals(initialCellXY, getCellXY());

        wrap.on('scroll', onScroll);

        this.removeCellMenuScrollListener = () => wrap.un('scroll', onScroll);

        function onScroll() {
            if (cellMoved()) {
                menu.hide();
            }
        }
    },

    onResize() {
        this.callParent(arguments);

        this.refreshLayout();
    },

    onValueCellClick(ev, el) {
        this.valueCellMenu.maybeShow({
            attribute: el.getAttribute('data-attribute'),
            location: el.getAttribute('data-location-series'),
            positionEl: el,
            view: this.projectView,

            onHide() {
                Ext.fly(el).removeCls('sa-quick-report-body-value-cell-selected');
            },

            onShow() {
                Ext.fly(el).addCls('sa-quick-report-body-value-cell-selected');
            }
        });
    },

    onValueCellMouseout(ev, el) {
        Ext.fly(el).removeCls('sa-quick-report-body-value-cell-over');
    },

    onValueCellMouseover(ev, el) {
        Ext.fly(el).addCls('sa-quick-report-body-value-cell-over');
    },

    onViewportResize() {
        this.refreshLayout();
    },

    refresh() {
        var view = this.projectView;

        if (!view.isViewable()) {
            return;
        }

        this.loadMask.show();

        view.checkAvailability().then(isAvailable => {
            if (isAvailable) {
                return view.getReportData().then(data => {
                    if (!this.el) {
                        return;
                    }

                    this.renderGrid(data);

                    this.loadMask.hide();
                });
            }
            else {
                Ext.widget({
                    xtype: 'alert',
                    message: 'Unfortunately your institution does not have access to Quick Reports. Please contact SimplyAnalytics support for more information at support@simplyanalytics.com.',
                    title: 'Quick Reports Unavailable'
                });

                view.getProject().removeView(view);
            }
        });
    },

    refreshAttributeTupleAddability() {
        var project = this.projectView.getProject(),
            labelCellEls = this.el.query('.sa-quick-report-first-col-data-row');

        labelCellEls.forEach(el => {
            var attributes = el.getAttribute('data-attributes').split(' '),
                canAddAttributes = attributes.some(attribute => !project.containsAttribute(attribute));

            Ext.fly(el).ifCls(canAddAttributes, 'sa-quick-report-first-col-data-row-with-addable-attribute');
        });
    },

    refreshLayout() {
        var didRenderGrid = this.grid.el.dom.hasChildNodes();

        if (!didRenderGrid) {
            return;
        }

        this.layout.refresh();

        this.scrollSynchronizer.syncAllToBody();
    },

    renderGrid(data) {
        this.grid.el.dom.innerHTML = this.gridTpl.apply(data);

        this.refreshAttributeTupleAddability();
        this.refreshLayout();
    },

    scrollLeftBy(delta) {
        this.scrollSynchronizer.scrollLeftBy(delta);
    },

    setLoadMaskSize(width, height) {
        this.loadMask.setSize(width, height);
    },

    setRefreshOnLocationChange(bool) {
        if (bool) {
            this.mon(this.projectView, 'change:location', this.refresh, this);
        }
        else {
            this.mun(this.projectView, 'change:location', this.refresh, this);
        }
    }
});